import { Component, Input, Signal } from '@angular/core';
import {
  LocationOfDevicesUnrelatedToRoadOccupationStageForm
} from '../../forms/location-of-devices-unrelated-to-road-occupation-stage.form';
import {
  DictTownRoadItem, DictTownStreetItem,
  DictTownWithRoadsItem,
  DictTownWithStreetsItem
} from '../../../../../../../../services/dictionary.common.model';
import { toSignal } from '@angular/core/rxjs-interop';
import { DictionaryCommonService } from '../../../../../../../../services/dictionary.common.service';
import { CommonModule } from '@angular/common';
import { ReactiveFormsModule } from '@angular/forms';
import { DatePickerComponent } from '../../../../../../../../common/date-picker/date-picker.component';
import {
  ValidationErrorsComponent
} from '../../../../../../../../common/validation-errors/validation-errors.component';
import { ParcelsCrudComponent } from '../../../../../common/components/parcels/parcels-crud/parcels-crud.component';
import { AlertComponent } from '../../../../../../../../common/alert/alert.component';
import { NgxMaskDirective } from 'ngx-mask';

@Component({
  selector: 'app-location-of-devices-unrelated-to-road-stage-form',
  standalone: true,
  imports: [
    CommonModule,
    ReactiveFormsModule,
    DatePickerComponent,
    ValidationErrorsComponent,
    ParcelsCrudComponent,
    AlertComponent,
    NgxMaskDirective
  ],
  templateUrl: './location-of-devices-unrelated-to-road-stage-form.component.html'
})
export class LocationOfDevicesUnrelatedToRoadStageFormComponent {
  @Input()
  public label: string = '';

  @Input()
  public form: LocationOfDevicesUnrelatedToRoadOccupationStageForm | undefined;

  @Input()
  public canRemoveStage = true;

  public townWithStreetsList: Signal<DictTownWithStreetsItem[] | undefined> = toSignal(this.dictService.getTownWithStreetsList());

  public townWithRoadsList: Signal<DictTownWithRoadsItem[] | undefined> = toSignal(this.dictService.getTownWithRoadsList());

  public getRoadList(townName?: string | null): Array<DictTownRoadItem> {
    return this.townWithRoadsList()?.filter(v => v.name === townName).at(0)?.roads || [];
  }

  public getStreetList(townName?: string | null): Array<DictTownStreetItem> {
    return this.townWithStreetsList()?.filter(v => v.name === townName)?.at(0)?.streets || [];
  }

  constructor(private dictService: DictionaryCommonService) {
  }

  public roadNumberChange(roadNumber: string): void {
    const roadName = this.getRoadList(this.form?.city.value).filter(v => v.roadNumber === roadNumber).at(0)?.roadName || '';
    this.form?.roadName?.setValue(roadName);
  }
}
